import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | Golden Touch Lash & Brow"
        description="The page you are looking for could not be found."
        path="/404"
        noindex
      />
      <section className="min-h-[70vh] bg-onyx flex items-center justify-center px-6 pt-24">
        <div className="text-center">
          <p className="font-script text-6xl text-gold">Oops</p>
          <h1 className="mt-4 font-display text-4xl md:text-5xl text-ivory">Page Not Found</h1>
          <p className="mt-5 max-w-md mx-auto text-muted-ivory">
            The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved. Let&rsquo;s get
            you back to something beautiful.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn-gold px-8 py-3 text-[0.72rem] tracking-[0.24em] uppercase">
              Back Home
            </Link>
            <Link
              to="/book"
              className="btn-gold-outline px-8 py-3 text-[0.72rem] tracking-[0.24em] uppercase"
            >
              Book Now
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
